export default "__VITE_ASSET__977b8c8b__"